import Vue from 'vue'
import Router from 'vue-router'
import Guard from './guard/middleware'

import Home from './views/Dashboard.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Flow from './views/Flow.vue'
import Users from './views/Users.vue'
import Admins from './views/Admins.vue'
import Settings from './views/Settings.vue'
import Attachments from './views/Attachments.vue'
import Livechat from './views/Livechat.vue'

/* powerbot-plugins-imports-begin */
import commentsMain from './powerbot-plugins/comments/views/Main.vue'
import nlpMain from './powerbot-plugins/nlp/views/Main.vue'
import pushesMain from './powerbot-plugins/pushes/views/Main.vue'
import refsMain from './powerbot-plugins/refs/views/Main.vue'
/* powerbot-plugins-imports-end */

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: Guard.guest
  }, {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: Guard.auth
  }, {
    path: '/',
    name: 'Dashboard',
    component: Home,
    beforeEnter: Guard.auth
  }, {
    path: '/flow',
    name: 'Flow',
    component: Flow,
    beforeEnter: Guard.auth
  }, {
    path: '/users',
    name: 'Users',
    component: Users,
    beforeEnter: Guard.auth
  }, {
    path: '/admins',
    name: 'Admins',
    component: Admins,
    beforeEnter: Guard.auth
  }, {
    path: '/attachments',
    name: 'Attachments',
    component: Attachments,
    beforeEnter: Guard.auth
  }, {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    beforeEnter: Guard.auth
  }, {
    path: '/livechat',
    name: 'Livechat',
    component: Livechat,
    beforeEnter: Guard.auth
  }
    /* powerbot-plugins-routes-begin */,
    {
      path: '/plugin/comments/main',
      name: 'commentscomments',
      component: commentsMain,
      beforeEnter: Guard.auth,
      meta: {
        plugin: true,
        showInNavbar: true,
        icon: 'comment-dots',
        pluginPrefix: 'comments',
        localeKey: 'title'
      }
    },
    {
      path: '/plugin/nlp/nlp',
      name: 'nlpNLP',
      component: nlpMain,
      beforeEnter: Guard.auth,
      meta: {
        plugin: true,
        showInNavbar: true,
        icon: 'brain',
        pluginPrefix: 'nlp',
        localeKey: 'nlp'
      }
    },
    {
      path: '/plugin/pushes/main',
      name: 'pushesMain',
      component: pushesMain,
      beforeEnter: Guard.auth,
      meta: {
        plugin: true,
        showInNavbar: true,
        icon: 'broadcast-tower',
        pluginPrefix: 'pushes',
        localeKey: 'title'
      }
    },
    {
      path: '/plugin/refs/main',
      name: 'refsreferences',
      component: refsMain,
      beforeEnter: Guard.auth,
      meta: {
        plugin: true,
        showInNavbar: true,
        icon: 'window-maximize',
        pluginPrefix: 'refs',
        localeKey: 'title'
      }
    }
/* powerbot-plugins-routes-end */
  ]
})
